import React, { useRef } from "react";
import { Button, Text, View } from "react-native";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import Landing from "../../../shared/components/Authentication/Landing/Landing";
import { ScreenAppMenu } from "../../../shared/utils/Constants";
import { AuthStartupGate } from "../../services/Authentication/AuthStartupGate";
import { useAuthSession } from "../../services/Authentication/AuthProvider";
import { getDeepLinkDestination, getReturnDestination } from "./AuthDestination";
import { getAppTarget } from "./Host";

function FirebaseSignInRoute() {
    const session = useAuthSession();
    const location = useLocation();
    // A signup creates a Firebase session before its profile/onboarding is complete.
    // Forms already call Navigation.relaunchApp when their full operation finishes.
    const arrivedAuthenticated = useRef(session.status === "authenticated");

    if (arrivedAuthenticated.current && session.status === "authenticated") {
        return <Navigate to={getReturnDestination(location.search)} replace />;
    }
    return <AuthStartupGate><Landing /></AuthStartupGate>;
}

export function SignInRoute() {
    const target = getAppTarget();
    return target === "public" || target === "lhq" ? <FirebaseSignInRoute /> : <Landing />;
}

export function AppEntryRoute() {
    const location = useLocation();
    return <Navigate to={getReturnDestination(location.search)} replace />;
}

export function NotFoundRoute() {
    const navigate = useNavigate();
    return <View style={{ padding: 24 }}>
        <Text>Cette page n’existe pas ou le lien est invalide.</Text>
        <Button title="Revenir à l’accueil" onPress={() => navigate(ScreenAppMenu, { replace: true })} />
    </View>;
}

export function DeepLinkRoute() {
    const location = useLocation();
    const destination = getDeepLinkDestination(location);
    return destination === null ? <NotFoundRoute /> : <Navigate to={destination} replace />;
}
